import queryEventLabel from "@/services/queryEventLabel"
import type { Payload as QueryEventLabelPayload } from "@/services/queryEventLabel"

export const useFetchQueryEventLabel = () => {
  const navbarStore = useNavbarStore()
  const { updateEventLabel } = navbarStore

  const fetch = async (payload: QueryEventLabelPayload) => {
    try {
      const { handler } = queryEventLabel

      const res = await handler({ payload })
      updateEventLabel(res)

      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return {
    fetch
  }
}

export default useFetchQueryEventLabel
